<template>
  <div>
    <ModuleHeader>Transacciones Contabilidad</ModuleHeader>
    <v-card flat>
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="6" md="6">
              <label>Fecha inicial</label>
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                  @selected="selectDate" :value="input_date.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
            <v-col cols="6" md="6">
              <div style="border-bottom: 1px solid; margin-bottom: -1px">
                <label>Fecha final</label>
                <Datepicker :input-class="'v-input__control theme--light v-text-field dateinputClass '"
                   @selected="selectDateFinal" :disabled-dates="disableDates"
                  :value="input_date_final.format('MM/DD/YYYY')"></Datepicker>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div class="buttons-container"></div>
            </v-col>
          </v-row>
        </v-form>

        <v-row>
          <v-col md="3" cols="6" class="mt-n6">
          <v-autocomplete
            label="Departamentos"
            v-model="selectDep"
            item-text="Nombre"
            item-value="id"
            :items="departamentos"
          ></v-autocomplete>
        </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-text-field v-model="transaccion" label="Autorización (Opcional)"></v-text-field>
          </v-col>
          <v-col md="3" cols="6" class="mt-n6">
            <v-text-field v-model="input_folio" label="Folio de Venta"></v-text-field>
          </v-col>
        </v-row>
        <v-btn @click="
          getVentas();
        " color="success" class="ma-1">
          Buscar
        </v-btn>
      </v-card-text>
    </v-card>
    <v-text-field v-model="cantFilter" label="Filtrar por Cantidad"></v-text-field>
    <div>
      <v-row>
        <v-col md="2"> Resultados: </v-col>
        <v-col md="3" class="text-right">

        </v-col>
        <v-col md="3" class="text-right">

        </v-col>
        <v-col md="3" class="text-right">
          <v-btn color="green" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon>
            Exportar a Excel
            <!-- <download-excel
              type="xls"
              name="Reporte transacciones"
              :data="excel_data"
            >
            </download-excel> -->
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="loadingData == true">
        <div>Cargando</div>
      </div>
      <v-simple-table class="dense-table">
        <thead>
          <tr>
            <th>Folio venta</th>
            <th>Depto.</th>
            <th>Fecha</th>
            <th>Id Autorización</th>
            <th>Alias</th>
            <th>Cliente</th>
            <th>Cajero</th>
            <th>Tipo de pago</th>
            <th>Cantidad Metodo de pago</th>
            <!-- <th>Propina</th> -->
            <th>Total Ticket</th>
            <!-- <th>Cambio</th> -->
            <th>Estatus</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="ventas_comp.length == 0">
            <td colspan="7">No se encontraron datos</td>
          </tr>
          <template v-for="(res, index) in ventas_comp">
            <tr :class="[
              res.match ? 'activeClass' : '',
              res.prop ? 'backgroundProp' : '',
              res.camb ? 'backgroundCamb' : '',
            ]" :key="index" v-if="res.show">
              <td>
                <b>{{ res.Folio }}</b><br/>
                <span class="text-caption" >{{res.Ref}}</span>
              </td>
               <td>
                <b>{{ res.Departamento.nm }}</b>
              </td>
              <td>{{ res.Turno.fe }}</td>
              <td>
                <b>{{ res.IdTran }}</b>
              </td>
              <td>
                {{ res.Cliente.Apodo }}
              </td>
              <td>{{ res.Cliente.Nombre }}</td>

              <td>
                {{ res.Cajero.nm }}
              </td>
              <td>{{ res.TipoPago }}</td>
              <td>
                <b>${{ formatNumber(res.Cantidad) }} {{ res.moneda }}</b>
              </td>
              <!-- <td>{{ $pgsHelper.formatNumber(res.PropinaTotal) }}</td> -->
              <td>
                <b>{{
                  $pgsHelper.formatNumber(res.Total.C)
                }}</b>
              </td>
              <!-- <td>
                    {{
                      $pgsHelper.formatNumber(res.Cambio ? res.Cambio.MXN : 0)
                    }}
                  </td> -->
              <td>
                <b v-show="!res.camb" v-bind:class="{
                  'blue--text': res.Devos,
                  'green--text': !res.Devos,
                }">{{ res.Devos ? "Devuelto" : "Activo" }}</b>
              </td>

              <td>
                <v-btn @click="showDetail(res)" small color="success">
                  Detalles
                </v-btn>
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Detalle de la venta">
      <resumenVenta :selectedRes="selectedRes" />
    </modal>

  </div>
</template>

<script>


import Datepicker from "vuejs-datepicker";
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import { mapGetters } from "vuex";
import Modificadores from "../../clases/Modificadores.js";
import resumenVenta from "../MainComponents/Contabilidad/ResumenVentaConta.vue";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import ReporteMetodosPago from "../../clases/PdfMakers/ReporteMetodosPago.js";
import ReporteMetodosPagoCliente from "../../clases/PdfMakers/ReporteMetodosPagoCliente.js";
import GenericExcelExporter from "../../clases/ExcelMaker/GeneralExcel.js";
import Currencies from "../../clases/Currencies.js";

export default {
  name: "ReporteTransacciones",
  components: {
    Datepicker,
    resumenVenta,
    modal,
  },
  props: ["hideMenu"],
  data() {
    return {
      selectedRows: [],
      confirmDialog: false,
      loading: false,
      Currency: Currencies,
      selectTurno: "ALL",
      aperturas: [],
      clientesSelected: [],
      meseros: [],
      showDevs: true,
      selectCaja: "",
      pagos: [],
      monedas: [],
      transaccion: "",
      loadingData: false,
      showEstad: false,
      input_date: moment(),
      input_date_final: moment(),
      selectedRes: "",
      input_caja: "",
      selectClient: "",
      input_cajero: "",
      input_folio: "",
      cajero: "ALL",
      data_cajas: [],
      showModal: false,
      formKey: 0,
      data_ventas: [],
      data_devoluciones: [],
      selectedHotel: "",
      hoteles: [],
      Horario: "",
      Horarios: [],
      selectDep: "ALL",
      cajeros: [{ id: "ALL", Nomb: "Todos" }],
      reservations: [],
      cantFilter: "",
      ventasSnapshot: [],
      devolucionesSnapshot: [],
    };
  },
  computed: {
    ...mapGetters(["getFirebaseApp"]),
    ...mapGetters(["getClientes", "getPDVPagosTipos", "getPDVMonedasLista"]),
    getPayMethods() {
      const pagos = {};

      this.$store.getters.getPDVPagosTipos.forEach((pago) => {
        if (pago.Moneda == "All") {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            pagos[pago.id + "_" + tipo.id] = {
              id: pago.id + "_" + tipo.id,
              Nombre: pago.Nombre + " " + tipo.Nombre,
            };
          });
        } else if (pago.Moneda == "None") {
          pagos[pago.id] = { id: pago.id, Nombre: pago.Nombre };
        } else {
          this.$store.getters.getPDVMonedasLista.forEach((tipo) => {
            if (tipo.id == pago.Moneda) {
              pagos[pago.id + "_" + tipo.id] = {
                id: pago.id + "_" + tipo.id,
                Nombre: pago.Nombre + " " + tipo.Nombre,
              };
            }
          });
        }
      });

      return pagos;
    },
    turnosList() {
      let dep = [
        {
          Turno: "ALL",
          Desc: "Todos",
          CajeroName: "Todos",
        },
      ];
      this.aperturas.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    departamentos() {
      let dep = [
        {
          id: "ALL",
          Nombre: "Todos",
        },
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((de) => {
        dep.push(de);
      });
      return dep;
    },
    ventas_comp() {
      this.data_ventas.forEach((venta) => {
        let totales = 0;
        for (const property in venta.Catalogo) {
          let totalProd = 0;
          let mesero = venta.Catalogo[property].ExtraParams?.AYB?.Mesero;

          
          if (venta.Catalogo[property].Pagos) {
            Object.entries(venta.Catalogo[property].Pagos).forEach((pago) => {
              totales += pago[1].def.C;
              totalProd += pago[1].def.C;
            });
          }
          venta.Mesero = this.$pgsHelper.getById(this.meseros, "id", mesero);
          venta.Catalogo[property].TotalReal = Number(totalProd);
        }

        venta.sumatoriaTotal = totales;
      });
      let data = this.data_ventas;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
    selectedReserva() {
      return this.selectedRes;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    contadoresTotales() {
      let dataContador = {};
      let encabezados = {};
      let totales = { Cambio: 0 };

      return {
        dataContador: dataContador,
        encabezados: encabezados,
        totales: totales,
      };
    },
    comp_clients() {
      let clientes = [];
      this.getClientes.forEach((cli) => {
        clientes.push({ id: cli.id, text: cli.Apellidos + " " + cli.Nombres });
      });
      return clientes;
    },
    comp_filter() {
      let filter = [];

      this.pagos.forEach((pago) => {
        this.monedas.forEach((moneda) => {
          filter.push(pago + "_" + moneda);
        });
      });
      return filter;
    },
    excel_data() {
      let dataExcel = [];
      this.data_ventas.forEach((venta) => {
        if (venta.show) {
          dataExcel.push({
            Folio: venta.Folio,
            Fecha: venta.Turno.fe,
            Cliente: venta.Cliente.Nombre,
            Alias: venta.Cliente.Apodo,
            Cajero: venta.Cajero.nm,
            Autorizacion: venta.IdTran,
            Clave: venta.clave,
            TipoPago: venta.TipoPago,
            Moneda: venta.moneda,
            TotalMetodoPago: venta.Cantidad,
            //TotalVenta: this.$pgsHelper.formatNumber(venta.Total.C),
            // Propina: this.$pgsHelper.formatNumber(venta.PropinaTotal),
            TotalTicket: this.$pgsHelper.formatNumber(venta.Total.C),
            // Cambio: this.$pgsHelper.formatNumber(
            //   venta.Cambio ? venta.Cambio.MXN : 0
            // ),
            Tipo: venta.prop ? "Propina" : venta.camb ? "Cambio" : "Pago",
          });
        }
      });
      let data = dataExcel;
      let array = data.sort(function (a, b) {
        if (b.Folio > a.Folio) return -1;
        if (b.Folio < a.Folio) return 1;
      });
      return array;
    },
  },
  methods: {
    onCheck() {
      console.log
    },
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excel_data)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Transacciones.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPago.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    generatePdfCliente() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        data: this.excel_data,
      };
      let docData = ReporteMetodosPagoCliente.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },

    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("HH:mm");
    },
    showDetail(res) {
      this.selectedRes = res;
      if (this.selectedRes) {
        let prod = Object.entries(this.selectedRes.Catalogo);
        this.selectedRes.ListProducts = prod;
        let pag = Object.entries(this.selectedRes.Pagos);
        this.selectedRes.ListPagos = pag;
      } else {
        this.selectedRes.ListProducts = [];
      }
      this.showModal = true;
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    formatNumber(num) {
      return num
      //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getVentas() {
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      this.loadingData = true;
      let arrayFilter = this.pagos;
      if (this.transaccion) {
        arrayFilter = arrayFilter.map((pago) => {
          return pago + "-" + this.transaccion;
        });
      }
      let listVentas = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filter = [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Turno.fe", ">=", startDate),
        firestore.where("Turno.fe", "<", end),
      ];
      if (this.selectDep != "ALL" && this.selectDep != "") {
        filter.push(firestore.where("Departamento.id", "==", this.selectDep));
      }
      if (this.input_folio != "") {
        filter.push(firestore.where("Folio", "==", this.input_folio));
      }

      const data = await firestore.queryBuilder("PDV_Ventas", filter);
      data.docs.map((doc) => {
        listVentas.push({ id: doc.ref.id, ...doc.data() });
      });
      let ventas = [];
      listVentas.forEach((venta) => {
        let propsMxn = 0;
        let propUSD = 0;
        if (venta.Props) {
          //let propinas = Object.entries(venta.Props);

          venta.Props.forEach((prop) => {
            /*let propSplit = prop[0].split("_");
            if (propSplit[1] == Currencies.getCurrencyDefault()) {
              propsMxn = propsMxn + prop[1].Cantidad;
            } else if (propSplit[1] == "USD") {
              propUSD = propUSD + prop[1].Cantidad;
            }*/
          });

          venta.Props.forEach((prop) => {
            //let propSplit = prop[0].split("_");

            
              ventas.push({
                prop: true,
                IdTran: "",
                TipoPago: prop.nm + " " + prop.rl.M + " Propina",
                Cantidad: prop.rl.C,
                moneda: prop.rl.M,
                PropinaTotal: propsMxn,
                PropinaUSD: propUSD,
                clave: prop.tp,
                show: true,
                ...venta,
              });
            
          });
        }

        if (venta.Cambio && venta.Cambio[Currencies.getCurrencyDefault()] > 0) {
          const negativeChange =
            -1 * Number(parseFloat(venta.Cambio[Currencies.getCurrencyDefault()]).toFixed(2));
          if (arrayFilter.length > 0) {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio " + Currencies.getCurrencyDefault(),
              Cantidad: Number(negativeChange),
              moneda: Currencies.getCurrencyDefault(),
              clave: Currencies.getCurrencyDefault(),
              show: this.comp_filter.includes(Currencies.getCurrencyDefault()),
              ...venta,
            });
          } else {
            ventas.push({
              camb: true,
              IdTran: "",
              TipoPago: "Cambio " + Currencies.getCurrencyDefault(),
              Cantidad: Number(negativeChange),
              moneda: Currencies.getCurrencyDefault(),
              clave: Currencies.getCurrencyDefault(),
              show: true,
              ...venta,
            });
          }
        }

        let pagos = Object.entries(venta.Pagos);
        pagos.forEach((pago) => {
          ventas.push({
              IdTran: pago[1].tn,
              TipoPago: pago[1].nm + " "+pago[1].rl.M,
              Cantidad: pago[1].rl.C,
              moneda: pago[1].rl.M,
              //propina: (pago[1].Props)?((pago[1].Props[pago[0]])?pago[1].Props[pago[0]]:0):0,
              propina: venta.Props
                ? venta.Props[pago[0]]
                  ? venta.Props[pago[0]].Cantidad
                  : 0
                : 0,
              clave: pago[1].tp,
              show: true,
              ...venta,
            });
        });
      });
      this.data_ventas = ventas;
      this.showEstad = true;
      this.loadingData = false;
    },
  },
  async mounted() {

  },
  beforeCreate: function () { },
  beforeMount: function () {
  },
};
</script>

<style scoped>
.backgroundProp {
  background-color: lightcyan;
}

.backgroundCamb {
  background-color: lightgoldenrodyellow;
}

.activeClass {
  background: #2185d075 !important;
}
</style>
